module.exports = __webpack_public_path__ + "img/bg-mision-1-4.94ca667a.jpg";